module.exports = __webpack_public_path__ + "static/media/angle-left.be4eedaa.svg";